import { HttpErrorResponse } from '@angular/common/http';
import { ApiError } from '@core/errors/api-error';

export class UnknownApiError extends ApiError {
  constructor(cause: HttpErrorResponse, body: unknown) {
    super('UnknownApiError', cause, body);
  }
}
